/**
 * @enum {number}
 *
 * Log levels that are used to define the logging threshold.
 */
export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  CRITICAL = 4,
}
